<div class="dialog-container">
  <div class="dialog-header mt-2">
    <div class="title">Logistics Detail Information</div>
    <button type="button" class="btn-close shadow-none" (click)="onClose()" title="Close"></button>
  </div>
  <div class="dialog-content mt-4">
    <div class="filter-container">
      <app-map-view-filter></app-map-view-filter>
    </div>
    <mat-accordion [multi]="true">
      <div class="mt-3">
        <mat-expansion-panel [expanded]="cardPanelOpen">
          <mat-expansion-panel-header>
            <mat-panel-title>Space</mat-panel-title>
          </mat-expansion-panel-header>
          <app-map-view-expandable-table [header]="tableHeader" [tableData]="spaceTableData"></app-map-view-expandable-table>
        </mat-expansion-panel>
      </div>
      <div class="mt-3">
        <mat-expansion-panel [expanded]="cardPanelOpen">
          <mat-expansion-panel-header>
            <mat-panel-title>Throughput</mat-panel-title>
          </mat-expansion-panel-header>
          <app-map-view-expandable-table [header]="tableHeader" [tableData]="throughputTableData"></app-map-view-expandable-table>
        </mat-expansion-panel>
      </div>
    </mat-accordion>
  </div>
</div>
